import { DEFAULT_LOCATION } from 'client/constants/location';

export function isDefaultZipCode(zipCode) {
  return zipCode === DEFAULT_LOCATION.zipCode;
}
